import React from 'react';
import {
  cssColorValue,
  screenMdMin,
  screenSmMax,
  screenXlMin,
  screenXxsMax,
  semanticColors,
  spacer16,
  spacer24,
  spacer32,
  spacer40,
  spacer48,
  spacer56,
} from '@spotify-internal/encore-web';
import styled from 'styled-components';

import { useVerticalConfig } from 'providers/vertical';

import { verticalMasthead } from '../constants';

import { FooterLogo } from './Logo';
import { FooterContent } from './Content';
import { FooterSocial } from './Social';
import { FooterCopyrightPolicies } from './CopyrightPolicies';
import { FooterLanguage } from './Language';

const FooterWrapper = styled.footer`
  background-color: ${cssColorValue(semanticColors.backgroundBase)};
  color: ${cssColorValue(semanticColors.textBase)};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacer56} ${spacer40} 0;
  gap: 96px;

  @media (max-width: ${screenSmMax}) {
    padding: ${spacer48} ${spacer40} 0;
    gap: ${spacer40};
    align-items: flex-start;
  }

  @media (max-width: ${screenXxsMax}) {
    padding: ${spacer48} ${spacer16} 0;
  }

  @media (min-width: ${screenXlMin}) {
    padding-inline: ${spacer48};
  }
`;

const FooterContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacer48};

  @media (min-width: ${screenMdMin}) {
    flex-direction: row;
  }
`;

const SubFooterWrapper = styled.div`
  border-top: solid 1px ${cssColorValue(semanticColors.decorativeSubdued)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${spacer24};
  flex: none;
  flex-direction: row;
  padding: ${spacer32} 0 ${spacer32} 0;
  @media (max-width: ${screenSmMax}) {
    flex-direction: column;
    padding: ${spacer24} 0 ${spacer24} 0;
  }
`;

export const TurnkeyFooter = () => {
  const { verticalName } = useVerticalConfig();
  const mastheadConfig = verticalMasthead[verticalName];
  if (!mastheadConfig) {
    return null;
  }

  const { footer: footerEntry, languageSelection: languageSelectionEntry } = mastheadConfig.linksConfig;

  return (
    <FooterWrapper className={mastheadConfig.colorSet}>
      <FooterContentWrapper>
        <FooterLogo />
        <FooterContent footerEntry={footerEntry} />
        <FooterSocial footerEntry={footerEntry} />
      </FooterContentWrapper>
      <SubFooterWrapper>
        <FooterCopyrightPolicies footerEntry={footerEntry} />
        <FooterLanguage languageSelectionEntry={languageSelectionEntry} />
      </SubFooterWrapper>
    </FooterWrapper>
  );
};
